function getStepName(loginType, isLoggedIn, noOrganizationAvailable) {
    switch (loginType) {
        case 'standAlone':
            if (isLoggedIn) {
                return 'StandAloneSelectOrganization';
            }

            return 'StandAloneLogin';
        case 'priceCalculation':
            if (!isLoggedIn) {
                return 'CalculationLogin';
            }

            if (noOrganizationAvailable) {
                return 'CalculationNoOrganizationAvailable';
            }

            return 'CalculationSelectOrganization';
        default:
            return '';
    }
}

export { getStepName };
